<script setup lang="ts">
import { useTransparentTheme } from './index'
import { useLanguage } from '@/composition'
import { getAssetsFile } from '@/utils/tool'
import mittBus from '@/utils/mitt'

defineOptions({ name: 'HeadNavigationMenu' })

const emit = defineEmits(['logout'])

const isInternationalFlag = window.isInternational

const route = useRoute()
const router = useRouter()
const { isTransparentTheme } = useTransparentTheme()
const { curLanguage } = useLanguage()

const headNavMenuLayRef = ref<HTMLElement | null>(null)
const showMainmenuContainer = computed(() => !new Set(['serviceAgreement']).has(route.name as string))
const showLoginContainer = computed<boolean>(() => !new Set(['serviceAgreement']).has(route.name as string))

const _curLanguage = unref(curLanguage)
/** logo容器内联样式 */
const changeLogoContainerStyle = computed(() => {
  if (!isInternationalFlag) {
    // 国内版
    const backgroundImage = unref(isTransparentTheme)
      ? getAssetsFile('headNavigationMenu/open_platform_cn_white_logo.png')
      : getAssetsFile('headNavigationMenu/open_platform_cn_logo.png')
    return {
      width: '224px',
      marginRight: '60px',
      backgroundImage: `url(${backgroundImage})`
    }
  } else {
    // 国际版
    const backgroundImage = unref(isTransparentTheme)
      ? getAssetsFile(`headNavigationMenu/open_platform_${_curLanguage}_white_logo.png`)
      : getAssetsFile(`headNavigationMenu/open_platform_${_curLanguage}_logo.png`)
    return {
      width: _curLanguage === 'en' ? '244px' : '224px',
      marginRight: _curLanguage === 'en' ? '40px' : '60px',
      backgroundImage: `url(${backgroundImage})`,
      flexShrink: 0
    }
  }
})

/**
 * 前往首页
 */
const toHome = () => {
  if (window.location.pathname === '/') return
  router.push({ name: 'home' })
}

/**
 * 头部导航菜单左右偏移处理(针对浏览器窗口小于1280时)
 */
const headNavgationMenuTransitionXHandler = () => {
  if (document.documentElement.scrollLeft > 0) {
    document.documentElement.scrollLeft <= 400 &&
      headNavMenuLayRef.value?.style.setProperty('transform', `translateX(-${document.documentElement.scrollLeft}px)`)
  }
}

/**
 * 头部导航菜单左右偏移内联样式去除
 */
const headNavgationMenuTransitionXRemoveHandler = () => {
  if (document.documentElement.offsetWidth >= 1280) {
    headNavMenuLayRef.value?.removeAttribute('style')
  }
}

mittBus.on('windowResize', headNavgationMenuTransitionXRemoveHandler)

// 这个滚动事件处理是主要针对头部导航菜单的左右偏移
window.addEventListener('scroll', headNavgationMenuTransitionXHandler)
</script>

<template>
  <div :class="['head-navigation-menu', isTransparentTheme && 'transparent-theme']">
    <div ref="headNavMenuLayRef" class="head-navigation-menu__layout">
      <div :style="changeLogoContainerStyle" class="head-navigation-menu__logo-container" @click="toHome" />
      <HeadNavMenuMainContainer v-if="showMainmenuContainer" :is-transparent-theme="isTransparentTheme" />
      <HeadNavMenuRightContainer
        v-if="showLoginContainer"
        :is-transparent-theme="isTransparentTheme"
        @logout="emit('logout')"
      />
    </div>
  </div>
</template>

<style scoped lang="less">
.head-navigation-menu {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  width: 100%;
  min-width: 1280px;
  min-height: @head-navigation-menu-height;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.04);
  z-index: 2499;
  transition: background-color 0.28s ease-in;
  &.transparent-theme {
    background-color: transparent;
  }
  &__layout {
    min-width: 1200px;
    margin: 0 40px;
    .flex(row, space-between, center);
  }
  &__logo-container {
    height: 80px;
    cursor: pointer;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: background-image 0.28s ease-in;
  }
}
</style>
